import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import Loading from '../Loading';
import InventoryHeader from './InventoryHeader';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import SKURowAdjustmentUpdate from './SKURowAdjustmentUpdate';
import InventoryComponentStockUpdate from './InventoryComponentStockUpdate';

const base = 'inventory-adjustment';

@inject('InventoryStore', 'ComponentStockStore', 'UserStore')
@observer
class InventoryAdjustmentUpdate extends Component {
    initialState = {
        showAdjustmentModal: false,
        quantity: 0,
        selectedBatch: {},
        showConfirmationModal: false,
        selectedReason: {},
        searchQuery: '',
    };

    state = this.initialState;

    componentDidMount = () => {
        const {
            ComponentStockStore: {
                getStockCountAvailability
            },
            UserStore: {
                position
            }
        } = this.props;
        if (position == 'Territory Manager') {
            this.initData();
        } else {
            getStockCountAvailability(this.hideLoader, this.initData);
        }
    };

    initData = () => {
        const {
            match: {
                params: { type },
            },
            InventoryStore: {
                handleGetProductionBatches,
                handleSetItemType,
                handleGetSKUSalesAvailability,
            },
        } = this.props;

        const itemType = type === 'meals' ? 'Item' : type === 'addons' ? 'Addons' : 'Component';
        if (itemType === 'Component') {

        } else {
            handleGetSKUSalesAvailability(itemType);
            handleSetItemType(itemType);
            handleGetProductionBatches(false);
        }
    };

    hideLoader = () => {
        const {
            InventoryStore
        } = this.props;
        InventoryStore.loading = false;
    }

    handleUnselectSku = () => {
        const {
            InventoryStore: { handleSetCurrentSku },
        } = this.props;

        handleSetCurrentSku('');
        this.setState({ quantity: 0 });
    };

    handleSearchQueryChange = (event) => {
        this.setState({ searchQuery: event.target.value });
    };

    render() {
        const {
            InventoryStore: {
                loading,
                productionBatches,
                skusByCategory,
                currentSku,
                itemType
            }
        } = this.props;
        const { searchQuery } = this.state;

        if (loading) {
            return <Loading />;
        }

        const normalizedSearchQuery = searchQuery.trim().toLowerCase();
        const filteredSkusByCategory = Object.keys(skusByCategory || {}).reduce((acc, category) => {
            const filteredSkus = skusByCategory[category].filter((sku) => (
                !normalizedSearchQuery ||
                sku.toLowerCase().includes(normalizedSearchQuery) ||
                category.toLowerCase().includes(normalizedSearchQuery)
            ));

            if (filteredSkus.length) {
                acc[category] = filteredSkus;
            }

            return acc;
        }, {});

        if (!currentSku) {
            return (
                <Fragment>
                    <InventoryHeader title='Choose SKU to update' />
                    <div className={`${base}__sku-list-wrapper pm`} style={{ maxWidth: '80%' }}>
                        <p className='fs--medium-large text--sofiapro text--left mbm'>
                            Select SKU
                        </p>
                        <div className={`${base}__search`}>
                            <input
                                className={`${base}__search-input`}
                                type="search"
                                value={searchQuery}
                                onChange={this.handleSearchQueryChange}
                                placeholder="Search SKU"
                            />
                        </div>
                        {Object.keys(filteredSkusByCategory).map((category) => (
                            <div
                                key={category}
                                className={`${base}__skus_of_one_sku_letter`}>
                                <div className={`${base}__sku-list-header row col-xs-12`} style={{marginTop: '48px', marginBottom: '24px'}}>
                                    <div className={`${base}__sku-list-heading ${base}__sku-list-heading--sku col-xs-4`} style={{paddingLeft: '5%'}}>
                                        <h3 className='text--left fs--medium-large text--bolder'>{category}</h3>
                                    </div>
                                    <div className={`${base}__sku-list-heading col-xs-2`}>
                                        <h2 className='fs--medium-medium-large text--bolder'>
                                            Unsold Stock
                                        </h2>
                                    </div>
                                    <div className={`${base}__sku-list-heading col-xs-2`}>
                                        <h2 className='fs--medium-medium-large text--bolder'>
                                            To hold
                                        </h2>
                                    </div>
                                    <div className={`${base}__sku-list-heading col-xs-2`}>
                                        <h2 className='fs--medium-medium-large text--bolder'>
                                            Marketing Activity
                                        </h2>
                                    </div>
                                </div>
                                {filteredSkusByCategory[category].map((sku) => {
                                    return (
                                        <SKURowAdjustmentUpdate
                                            sku={sku}
                                            itemType={itemType}
                                            key={sku}
                                        />
                                    );
                                })}
                            </div>
                        ))}
                        {Object.keys(filteredSkusByCategory).length === 0 && (
                            <div className={`${base}__empty-results`}>
                                No SKUs found.
                            </div>
                        )}
                    </div>
                </Fragment>
            );
        }

        const { batches } = productionBatches[currentSku];
        const startDate = (batch) =>
            moment(batch.arrival_at, 'x').format('DD/MM/YYYY');
        const endDate = (batch) =>
            moment(batch.expires_at, 'x')
                .subtract(1, 'days')
                .format('DD/MM/YYYY');

        return (
            <Fragment>
                <InventoryHeader
                    title={`${
                        itemType === 'Item'
                            ? currentSku.split('_')[0]
                            : currentSku
                    } Quick Stock Update`}
                    onClickBackLink={this.handleUnselectSku}
                />
                {batches
                    .slice()
                    .sort((a, b) => a.expires_at - b.expires_at)
                    .map((batch) => (
                        <Fragment key={batch.id}>
                            <div
                                className={`fs--medium-large ps bg--black text--white`}
                            >
                                {`${startDate(batch)} - ${endDate(batch)}`}
                            </div>
                            <div
                                className={`pl row col-lg-12`}
                            >
                                <div className='text--left col-lg-6 col-sm-12 col-xs-12'>
                                    <p className='text--bolder fs--medium-large'>
                                        {itemType === 'Item'
                                            ? currentSku.split('_')[0]
                                            : currentSku}
                                    </p>
                                    <p className='fs--medium-large'>{`${batch.virtual_stock} Meals in the Hub`}</p>
                                    <p className='fs--medium-large'>{`${batch.virtual_stock - batch.quantity_left} Pre-orders`}</p>
                                </div>
                            </div>
                            <div className={`pl row col-lg-12`}>
                            <InventoryComponentStockUpdate  fromMealUpdateScreen ={true}/>
                            </div>
                        </Fragment>
                    ))}
            </Fragment>
        );
    }
}

export default withRouter(InventoryAdjustmentUpdate);
